module.exports = __webpack_public_path__ + "static/media/news2.c399fa2c.png";